export const SET_PA_DENIAL_CODE_MAP_CLEAR_MESSAGE = 'clearMessage';
export const SET_PA_SEARCH_DENIAL_CODE_MAP_COMPLETE = 'setPASearchDenialCodeMap';
export const SET_PA_SEARCH_DENIAL_CODE_MAP_EXPORT_COMPLETE = 'setPASearchDenialCodeMapExport';
export const SET_PA_GET_DENIAL_CODE_MAP_COMPLETE = 'setPAGetDenialCodeMap';
export const SET_PA_DENIAL_CODE_MAP_BUSY = 'setPADenialCodeMapBusy';



// WEBPACK FOOTER //
// ./src/store/denial-code-map/mutations.type.js